module.exports = __webpack_public_path__ + "static/img/IMG_20160227_201224.d3a2718c.jpg";